import React, { useEffect, useState } from "react";
import { Affix, Space, Button, Drawer } from "antd";
import { ShoppingCartOutlined, UserOutlined, MenuOutlined, SearchOutlined } from '@ant-design/icons';
import search_bar from "../media/search_bar.png"
import { getColor } from "../utils/ConvertCSS";
import { useTemplate } from "../utils/Template";
import CSS from "../utils/CSS";
import conditional from "../utils/conditional";
import { usePrefs } from "../utils/Prefs";
import { fetchImage } from "../utils/Api";
import SiteNav from "./SiteNav";

export default function SiteSearchBar(props) {

    const [prefs, ] = usePrefs();
    const [template, ] = useTemplate();
    const { view = "desktop", containerRef = {}, menus, page, setPage, open} = props;
    const [mobileMenu, setMobileMenu] = useState(false);

    // Destructure universal settings
    const {
        container = true,
        data = {},
    } = prefs.search_bar;

    // Destructure component specific settings
    const {
        background_colour = 0,
        text_colour = 0,
        text_hover_colour = 0,
        search_bar_logo = "",
        pin_navigation = true,
        logo_height = 40,
        padding_x = 0,
        padding_y = 0,
        drop_shadow = true,
    } = data;

    const is_mobile = (view !== "desktop");

    // Write class 
    let _class = ``;

    _class += `
    .search_bg {
        background: ${getColor(background_colour, template, "#000")};
        color:  ${getColor(text_colour, template, "#fff")};
        height: calc(20px + ${(logo_height + padding_y + padding_y) + "px"})
    }`;

    _class += `
    .search_bg .logo {
        max-width : 300px;
        max-height : ${logo_height}px;
        width : auto; 
        height : auto:
    }`;

    _class += `
    .search_bg .logo-mobile {
        max-width : 100%;
        max-height : ${logo_height}px;
        width : auto; 
        height : auto:
    }`;

    _class += `
    .search_bg .float-flex{
        align-items : center;
        height: calc(20px + ${(logo_height + padding_y + padding_y)}px)
    }`;

    _class += `
    .search_bg .ant-btn:not(:hover) {
        color:  ${getColor(text_colour, template, "#fff")} !important;
        border-color:  ${getColor(text_colour, template, "#fff")} !important;
       
    }`;

    _class += `
    .search_bg .ant-btn:hover {
        color:  ${getColor(text_hover_colour, template, "#eee")} !important;
        border-color:  ${getColor(text_hover_colour, template, "#eee")} !important;
    }`;


    useEffect(() => {
        if (props.editing) {
            switch (props.selected) {
                case "search_bar":
                    containerRef.current.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                    break;
                case "nav_bar":
                    containerRef.current.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                    break;
                case "footer_bar":
                    containerRef.current.scrollTo({
                        top: containerRef.current.scrollHeight,
                        behavior: 'smooth'
                    });
                    break;
                default:
                break;
            }
        }

    }, [props.editing])

    // Draw the logo, or the title if there is no logo
    const drawLogo = () => {

        if (search_bar_logo) {
            return (
                <div style={{ "padding": "5px 0px" }}><img alt="logo" className={(is_mobile) ? "logo-mobile" : "logo"} src={fetchImage(search_bar_logo)} /></div>
            )
        } else {
            return (<div style={{ "fontSize": "18px", "fontWeight": "600", "marginTop": "2px" }}>{window.sitesettings.stores.find(item => item.is_primary).name}</div>)
        }
    }

    // Draw the search bar for desktop or mobile
    const draw = () => {

        return (
            <div id="search_bg" className={(drop_shadow) ? "search_bg headerShadow bm-render" : "search_bg bm-render"} style={{ "maxWidth": "100%", position: "relative" }}>
                <div style={{ "maxWidth": (container) ? "1248px" : "100%", "margin": "0 auto", "padding": (!is_mobile && container) ? "0px 0px" : "0px 20px" }} className="float-flex">
                    {/* Desktop */}
                    <conditional.true value={(view === "desktop")}>
                        <Space size={20}>
                            <div style={{ "padding": padding_y + "px " + padding_x + "px" }}>{drawLogo()}</div>
                            <div><img alt="searchbar" src={search_bar} /></div>
                        </Space>
                        <Space size={5}>
                            <Button className="search_txt search_txt_border" ghost><UserOutlined className="search_txt" />Login</Button>
                            <Button style={{ "border": "none" }} className="search_txt search_txt_border" type="text"><ShoppingCartOutlined style={{ "fontSize": "23px" }} className="icon-btn" /></Button>
                        </Space>
                    </conditional.true>
                    {/* Mobile */}
                    <conditional.true value={(view !== "desktop")}>
                        <div style={{ "maxWidth": "100%" }}>{drawLogo()}</div>
                        <Space size={0}>
                            <Button style={{ "border": "none" }} className="search_txt search_txt_border" type="text"><UserOutlined style={{ "fontSize": "19px" }} className="icon-btn" /></Button>
                            <Button style={{ "border": "none" }} className="search_txt search_txt_border" type="text"><ShoppingCartOutlined style={{ "fontSize": "19px" }} className="icon-btn" /></Button>
                            <Button style={{ "border": "none" }} className="search_txt search_txt_border" type="text"><SearchOutlined style={{ "fontSize": "19px" }} className="icon-btn" /></Button>
                            <Button style={{ "border": "none" }} className="search_txt search_txt_border" type="text"><MenuOutlined style={{ "fontSize": "19px" }} onClick={() => setMobileMenu(true)} className="icon-btn" /></Button>
                        </Space>
                    </conditional.true>

                    <conditional.true value={(view !== "desktop")}>
                        <Drawer
                            title="Menu"
                            style={{ "padding": "0px", position: "absolute", height: "100vh", overflow: "hidden"}}
                            placement="right"
                            width="250px"
                            mask={false}
                            className="mobile_drawer"
                            closable={true}
                            open={mobileMenu}
                            getContainer={() => document.querySelector('#search_bg')}
                            onClose={() => setMobileMenu(false)}
                        >
                            <SiteNav mobile menus={menus} page={page} setPage={setPage} setMobileMenu={setMobileMenu}/>
                        </Drawer>
                    </conditional.true>
                </div>
            </div>
        )
    }

    // Draw pinned or scrolling
    return (
        <div style={{ "position": "relative", "zIndex": "12" }}>
            <CSS html={_class} />
            <conditional.true value={(pin_navigation)}>
                <Affix target={() => containerRef.current} offsetTop={0}><div>{draw()}</div></Affix>
            </conditional.true>
            <conditional.true value={(!pin_navigation)}>
                <div style={{ "marginTop": "0px" }}>{draw()}</div>
            </conditional.true>
        </div>
    )
}